import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'

@ObjectType()
export class Image extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  originalUrl: string

  @Field(() => String)
  @Prop({ type: String })
  thumb: string

  @Field(() => String)
  @Prop({ type: String })
  size_1?: string

  @Field(() => String)
  @Prop({ type: String })
  size_2?: string

  @Field(() => String)
  @Prop({ type: String })
  size_3?: string
}
